export function removeNullProperties<T>(obj: Object): T {
    Object.keys(obj).forEach((k) => (obj[k] == null || obj[k] === '') && delete obj[k]);
    return obj as T;
}